import styled from 'styled-components';

export const ErrorFallback = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  padding: 2rem;
  text-align: center;

  h2 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.colors?.textPrimary || '#333'};
  }

  p {
    margin-bottom: 1.5rem;
    color: ${({ theme }) => theme.colors?.textSecondary || '#666'};
  }

  button {
    padding: 0.75rem 1.5rem;
    font-size: 1rem;
    background: ${({ theme }) => theme.colors?.primary || '#047f30'};
    color: white;
    border: none;
    border-radius: 0.25rem;
    cursor: pointer;

    &:hover {
      opacity: 0.9;
    }
  }
`;
